export interface ConsentState {
    necessary: true;
    analytics: boolean;
    decided: boolean;
    updatedAt: string | null;
}

const CONSENT_STORAGE_KEY = 'lm_cookie_consent';
const CONSENT_COOKIE = 'lm_cookie_consent';

const defaultConsentState: ConsentState = {
    necessary: true,
    analytics: false,
    decided: false,
    updatedAt: null,
};

const readCookie = (name: string) => {
    if (typeof document === 'undefined') return null;
    const entry = document.cookie
        .split('; ')
        .find((part) => part.startsWith(`${name}=`));
    return entry ? decodeURIComponent(entry.split('=').slice(1).join('=')) : null;
};

const getStorage = () => (typeof window !== 'undefined' ? window.localStorage : null);

export const getConsentState = (): ConsentState => {
    const storage = getStorage();
    const raw = storage?.getItem(CONSENT_STORAGE_KEY) || readCookie(CONSENT_COOKIE);
    if (!raw) return defaultConsentState;

    try {
        const parsed = JSON.parse(raw);
        return {
            necessary: true,
            analytics: Boolean(parsed.analytics),
            decided: Boolean(parsed.decided),
            updatedAt: parsed.updatedAt || null,
        };
    } catch {
        return defaultConsentState;
    }
};
